import {CssInstance} from '@superweb/css'
import {LocaleProvider} from '@superweb/intl'
import {AppContainer, Messages, UiOptions} from '@superweb/ui'
import type {FC, PropsWithChildren} from 'react'

import {GutsRevealer} from './GutsRevealer'

type Props = PropsWithChildren<{locale: string}>

export const SuperwebProvider: FC<Props> = ({children, locale}) => (
  <LocaleProvider value={locale}>
    <Messages>
      <CssInstance>
        <UiOptions
          value={{
            experimental: {
              alertInfoBlackBackground: true,
            },
          }}
        >
          <AppContainer>
            <GutsRevealer />
            {children}
          </AppContainer>
        </UiOptions>
      </CssInstance>
    </Messages>
  </LocaleProvider>
)

SuperwebProvider.displayName = 'SuperwebProvider'
